'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const CollapsibleSummaryTextClosed = renderWithRef('CollapsibleSummaryTextClosed', null, (r, s)=>jsx(RenderComp, {
        root: "span",
        forwardedRef: s,
        classNames: [
            'swan-collapsible-summary-text-closed'
        ],
        props: r,
        children: r.children
    }));

export { CollapsibleSummaryTextClosed };
